"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var antd_1 = require("antd");
var react_1 = __importDefault(require("react"));
var react_i18next_1 = require("react-i18next");
var store_1 = require("../../store");
var Option = antd_1.Select.Option;
var LocaleSelector = function () {
    var appConfig = store_1.useStore(function (state) { return state.ui.appConfig; });
    var i18n = react_i18next_1.useTranslation().i18n;
    var handleChange = function (key) {
        i18n.changeLanguage(key);
    };
    return (react_1.default.createElement(antd_1.Select, { value: i18n.language, onChange: handleChange, className: "ant-select-locale" }, appConfig.translations &&
        appConfig.translations.map(function (item) { return react_1.default.createElement(Option, { key: item.locale }, item.locale.substr(0, 2).toUpperCase()); })));
};
exports.default = LocaleSelector;
